const alertItemsDefaultState = {
    data: {},
    loading: false,
    error: false,
    success: false,
    successMessage: '',
    errorMessage: null
};

const alertItemReducer = (state = alertItemsDefaultState, action) => {
    switch (action.type) {
        case 'START_GET_ALERT_ITEM':
            return {
                ...state,
                loading: true,
                error: false,
                errorMessage: null,
                successMessage: '',
                success: false
            };
        case 'GET_ALERT_ITEM_SUCCESS':
            return {
                ...state,
                data: action.alertDetails,
                loading: false,
                error: false,
                errorMessage: null,
            };
        case 'CREATE_ALERT_SUCCESS':
            return {
                ...state,
                data: action.alertDetails,
                loading: false,
                success: true,
                error: false,
                errorMessage: null,
                successMessage: 'News Alert has been updated',
            };
        case 'START_ALERT_ITEM_UPDATE':
            return {
                ...state,
                loading: true,
                error: false,
                errorMessage: null,
                successMessage: '',
            };
        case 'UPDATE_ALERT_ITEM_SUCCESS':
            return {
                ...state,
                data: action.alertDetails,
                loading: false,
                success: true,
                error: false,
                errorMessage: null,
                successMessage: 'Microsite has been updated',
            };
        case 'START_ALERT_ITEM_DELETE':
            return {
                ...state,
                loading: true,
                error: false,
                errorMessage: null,
                successMessage: '',
            };
        case 'SHOW_ERROR':
            return {
                ...state,
                loading: false,
                error: true,
                successMessage: '',
                errorMessage: action.errorMessage
            };
        default:
            return state;
    }
};

export default alertItemReducer;